module.exports = __webpack_public_path__ + "img/tail-spin-registration.994b3453.svg";